import Vue from 'vue'
import store from './store'
import Drawer from './components/drawer.vue'
import Selector from './components/selector.vue'
import Close from './components/close.vue'
import './../bankrate-credit-cards-new/bankrate-credit-card-categories/cc-bankrate-score'
import utilities from 'apps/utility/vue-common'
import _ from 'lodash'

if (
  document.getElementById('card-compare-drawer') &&
  !document.getElementById('card-comparison-table-wrapper')
) {
  new Vue({
    el: '#card-compare-drawer',
    store,
    components: {
      'card-compare-drawer': Drawer
    },
    beforeCreate() {
      this.$store.commit('initializeStore')
    }
  })
}

let cardSelectors = document.querySelectorAll('.card-compare-selector')
_.forEach(cardSelectors, container => {
  new Vue({
    el: container,
    store,
    components: {
      'card-compare-selector': Selector
    },
    beforeCreate() {
      this.$store.commit('initializeStore')
    }
  })
})

let cardCloseButtons = document.querySelectorAll('.card-close-button')
_.forEach(cardCloseButtons, container => {
  new Vue({
    el: container,
    store,
    components: {
      'card-close-button': Close
    },
    beforeCreate() {
      this.$store.commit('initializeStore')
    }
  })
})

let compareTablesWrapper = document.getElementById(
  'card-comparison-table-wrapper'
)

if (compareTablesWrapper) {
  let ticking = false
  let compareTableHeader = document.getElementById('compare-cards-header-table')
  let compareTableDetails = document.getElementById(
    'compare-cards-detail-table'
  )
  let compareTableDetailsWrapper = document.getElementById(
    'compare-cards-detail-table-wrapper'
  )

  const checkTablePosition = () => {
    let lastPosition = window.scrollY

    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (lastPosition < compareTablesWrapper.offsetTop) {
          compareTableHeader.classList.remove('--smaller-images')
          compareTableHeader.classList.remove('--fix-table-top')
          compareTableDetailsWrapper.style.marginTop = 0
        } else {
          compareTableHeader.classList.add('--smaller-images')
          compareTableHeader.classList.add('--fix-table-top')
          compareTableDetailsWrapper.style.marginTop =
            compareTableHeader.scrollHeight + 'px'
        }
        ticking = false
      })
      ticking = true
    }
  }

  const checkLeftHeaderPosition = () => {
    let leftPosition = compareTablesWrapper.scrollLeft * -1
    compareTableHeader.style.left = leftPosition + 'px'

    let spanners = document.querySelectorAll('.header-span-adjustment')
    _.forEach(spanners, container => {
      if (compareTableDetails.offsetWidth > window.innerWidth) {
        container.style.width = window.innerWidth + 'px'
        container.style.left = compareTablesWrapper.scrollLeft + 'px'
      } else {
        container.style.width = '100%'
        container.style.left = 'auto'
      }
    })
  }

  if (
    window.innerHeight > compareTableHeader.offsetHeight * 1.75 ||
    utilities.methods.isMobile()
  ) {
    window.addEventListener('scroll', function() {
      checkTablePosition()
    })

    compareTablesWrapper.addEventListener('scroll', function() {
      checkLeftHeaderPosition()
    })

    checkTablePosition()
    checkLeftHeaderPosition()
  }

  if (utilities.methods.isMobile()) {
    let compareTables = document.querySelectorAll('.compare-cards-table')
    _.forEach(compareTables, container => {
      if (window.cardCount > 2) {
        let widthPercentage = window.innerWidth * 0.46
        console.log(window.cardCount, widthPercentage)
        container.style.width = widthPercentage * window.cardCount + 'px'
      }
    })
  }
}
